import { useActorRef } from '@xstate5/react';
import { type ActorRefFrom } from 'xstate5';

import { LastInteractedStoreMachine } from './LastInteractedStore.machine';

// ────────────────────────────────────────────────────────────────────────────────

export const useInitLastInteractedStoreMachine = () => useActorRef(LastInteractedStoreMachine);

export type LastInteractedStoreMachineRefType = ActorRefFrom<typeof LastInteractedStoreMachine>;
